module.exports = __webpack_public_path__ + "img/pepper-money.c5d44a9a.png";